import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { GatekeeperService } from '@vanguard/secure-site-components-lib';
import { fromEvent, Observable, ReplaySubject } from 'rxjs';

interface FocusPanelAccount {
  accountId: string;
  accountName: string;
}

const FeatureId = {
  ENABLE_FOCUS_PANEL: 'enable_focus_panel',
};

export interface FocusPanelDTO {
  accounts: FocusPanelAccount[];
  isAllAssets: boolean;
  displayName: string;
}

@Injectable({
  providedIn: 'root',
})
export class FocusPanelService {
  private DEFAULT_FOCUS_PANEL_DATA: FocusPanelDTO = {
    accounts: [],
    isAllAssets: true,
    displayName: 'All assets',
  };

  private readonly FOCUS_PANEL_ENDPOINT: string = environment['FOCUS_PANEL_API'];
  private focusPanelSubject$: ReplaySubject<FocusPanelDTO> = new ReplaySubject<FocusPanelDTO>(1);
  public isListenerAttached: boolean = false;

  constructor(
    private readonly http: HttpClient,
    private readonly gatekeeperService: GatekeeperService,
  ) {}

  public loadFocusPanelData(): void {
    this.http.get<FocusPanelDTO>(this.FOCUS_PANEL_ENDPOINT, { withCredentials: true }).subscribe({
      next: (data) => {
        this.focusPanelSubject$.next(data);
      },
      error: (error) => {
        this.focusPanelSubject$.next(this.DEFAULT_FOCUS_PANEL_DATA);
      },
    });
  }

  public getFocusPanelData(): Observable<FocusPanelDTO> {
    return this.focusPanelSubject$.asObservable();
  }

  public listenForFocusPanelChanges(): void {
    const panelElement = document.querySelector('ss-panel');
    if (panelElement) {
      fromEvent<CustomEvent>(panelElement, 'mfeSelect').subscribe((event: CustomEvent) => {
        this.focusPanelSubject$.next(event.detail);
      });
      this.isListenerAttached = true;
    }
  }

  public async isFocusPanelEnabled(): Promise<boolean> {
    const focusPanelValue = new URLSearchParams(window.location.search).get('focusPanel');
    const gkStatus = await this.gatekeeperService.getStatus(FeatureId.ENABLE_FOCUS_PANEL);

    return Boolean(gkStatus && focusPanelValue === 'true');
  }
}
